import { routerGetCall } from '../../axios';

const getPolicyDocuments = (state, params) => {
    const url = `/accounts/policies/${params?.policyId}/documents`;
    return routerGetCall(state, url, {});
};
export default { getPolicyDocuments };